module.exports = __webpack_public_path__ + "static/img/dia-del-nino-2.e8d63d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/dia-del-nino-2.jpg
// module id = ABFz
// module chunks = 1